var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"id":"isfScore","width":"100%","height":"154","frameborder":"0","scrolling":"no","src":'https://widgets.sofascore.com/embed/attackMomentum?id=' +
      _vm.$route.params.idEvento +
      '&widgetBackground=White'}})])}
var staticRenderFns = []

export { render, staticRenderFns }